export const INFINITE_SCROLL_OFFSET_DESKTOP = '-100px';
export const INFINITE_SCROLL_OFFSET_MOBILE = '-75px';
